<template>
  <aside class="main-sidebar sidebar-dark-primary elevation-4">
    <!-- Brand Logo -->
    <router-link to="/dashboard" class="brand-link text-center d-flex align-items-center justify-content-center">      
      <img src="minilogo.png" alt="De Park Logo" class="brand-image me-2" />
      <span class="brand-text fw-bold text-white">De Park</span>
    </router-link>

    <!-- Sidebar -->
    <div class="sidebar">
      <nav class="mt-3">
        <ul class="nav nav-pills nav-sidebar flex-column" role="menu" data-accordion="false">
          
          <!-- Dashboard -->
          <li class="nav-item">
            <router-link
              to="/dashboard"
              class="nav-link"
              :class="{ active: $route.path === '/dashboard' }"
            >
              <i class="nav-icon fas fa-tachometer-alt"></i>
              <p>Dashboard</p>
            </router-link>
          </li>

          <!-- Profile with submenu -->
          <li class="nav-item" :class="{ menuOpen: isProfileOpen }">
            <a href="#" class="nav-link" 
              :class="{ active: $route.path.startsWith('/profile')}" 
              @click.prevent="toggleProfile">
              <i class="nav-icon fas fa-user"></i>
              <p>
                Profile
                <i class="right fas fa-angle-left"></i>
              </p>
            </a>

            <ul class="nav nav-treeview" v-show="isProfileOpen">
              <li class="nav-item">
                <router-link to="/profile" class="nav-link" :class="{ active: $route.path === '/profile' }">
                  <i class="far fa-circle nav-icon"></i>
                  <p>View Profile</p>
                </router-link>
              </li>
            </ul>
          </li>

          <!-- Warga (hanya Owner) -->
          <li v-if="userRole === 'Owner'" class="nav-item" :class="{ menuOpen: isWargaOpen }">
            <a href="#" class="nav-link"
              :class="{ active: $route.path.startsWith('/datawarga') }"
              @click.prevent="toggleWarga">
              <i class="nav-icon fas fa-users"></i>
              <p>
                Warga
                <i class="right fas fa-angle-left"></i>
              </p>
            </a>

            <ul class="nav nav-treeview" v-show="isWargaOpen">
              <li class="nav-item">
                <router-link to="/datawarga" class="nav-link" :class="{ active: $route.path === '/datawarga' }">
                  <i class="far fa-circle nav-icon"></i>
                  <p>Data Warga</p>
                </router-link>
              </li>
            </ul>
          </li>

          <!-- Logout -->
          <li class="nav-item">
            <a href="#" class="nav-link text-danger" @click.prevent="logout">
              <i class="nav-icon fas fa-sign-out-alt"></i>
              <p>Log Out</p>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </aside>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import alert from '@/utils/alert'

const router = useRouter()
const route = useRoute()

// nested menu control
const isProfileOpen = ref(false)
const isWargaOpen = ref(false)

// role user dari session/localStorage
const userRole = ref(localStorage.getItem('akses') || '') // ambil dari session login

// Toggle submenu Profile
function toggleProfile() {
  isProfileOpen.value = !isProfileOpen.value
}

// Toggle submenu Warga
function toggleWarga() {
  isWargaOpen.value = !isWargaOpen.value
}

// Auto open submenu sesuai route
watch(
  () => route.path,
  (newPath) => {
    isProfileOpen.value = newPath.startsWith('/profile')
    isWargaOpen.value = newPath.startsWith('/datawarga')
  },
  { immediate: true }
)

// Logout
function logout() {
  alert.warning('Anda yakin ingin log out?').then((result) => {
    if (result.isConfirmed) {
      localStorage.clear()
      sessionStorage.clear()
      router.push('/')
    }
  })
}
</script>

<style scoped>
.nav-sidebar .nav-link {
  transition: all 0.3s ease;
}

.nav-sidebar .nav-link.active {
  background-color: #198754 !important;
  color: #fff !important;
  font-weight: bold;
}

.nav-sidebar .nav-link:hover {
  background-color: #157347 !important;
  color: #fff !important;
}

.nav-item.menuOpen > .nav-treeview {
  display: block;
}

.nav-treeview {
  padding-left: 1rem;
  background-color: #2d3238;
}

.nav-treeview .nav-link.active {
  background-color: #14532d !important;
  color: #fff;
}
</style>
